<template>
  <div>
    <b-row>
      <b-col lg="8" md="12" sm="12">
        <b-card class="ps-card">
          <template #header>
            <b-row class="pt-1">
              <b-col cols="10" class="d-flex">
                <h4 class="me-2">
                  {{ $route.meta.label }}
                  <small class="fw1">
                    {{label.pages.profilePhoto}}
                  </small>
                </h4>
              </b-col>
              <b-col cols="2" class="dir-text-start">
                <a
                    @click="$router.go(-1)"
                    v-b-tooltip.hover.right
                    :title="label.pages.previousPage"
                    class="mouse-change pe-3"
                >
                  <b-icon
                      icon="arrow-left-square-fill"
                      variant="ps-base"
                      scale="1.2"
                      class="align-middle ms-1"
                  />
                </a>
              </b-col>
            </b-row>
          </template>
          <b-card-text>
            <b-row>
              <b-col cols="6">
                <b-row class="my-4 mb-2">
                  <b-col cols="3">
                    <label for="firstName" class="ps_label">
                      {{label.form.firstName}}
                    </label>
                  </b-col>
                  <b-col cols="9">
                    <b-form-input id="firstName" size="sm" v-model="form.firstName"/>
                  </b-col>
                </b-row>
                <b-row class="my-4 mb-2">
                  <b-col cols="3">
                    <label for="lastName" class="ps_label">
                      {{label.form.lastName}}
                    </label>
                  </b-col>
                  <b-col cols="9">
                    <b-form-input id="lastName" size="sm" v-model="form.lastName"/>
                  </b-col>
                </b-row>
                <b-row class="my-4 mb-2">
                  <b-col cols="3">
                    <label for="mobileNumber" class="ps_label">
                      {{label.form.phoneNumber}}
                    </label>
                  </b-col>
                  <b-col cols="9">
                    <b-form-input
                      id="mobileNumber"
                      size="sm"
                      v-model="form.mobileNumber"
                      class="text-center"
                      disabled
                    />
                  </b-col>
                </b-row>
                <b-row class="my-4 mb-2">
                  <b-col cols="3">
                    <label for="tel" class="ps_label">
                      {{label.form.phone}}
                    </label>
                  </b-col>
                  <b-col cols="9">
                    <b-form-input
                      id="tel"
                      size="sm"
                      type="number"
                      v-model="form.tel"
                      class="text-center"
                    />
                  </b-col>
                </b-row>
                <b-row class="my-4 mb-2">
                  <b-col cols="3">
                    <label for="email" class="ps_label">
                      {{label.form.email}}
                    </label>
                  </b-col>
                  <b-col cols="9">
                    <b-form-input
                      id="email"
                      size="sm"
                      type="email"
                      class="text-start"
                      v-model="form.email"
                    />
                  </b-col>
                </b-row>
                <b-row class="my-4 mb-2">
                  <b-col cols="3">
                    <label for="nationalCode" class="ps_label">
                      {{label.form.nationalCode}}
                    </label>
                  </b-col>
                  <b-col cols="9">
                    <b-form-input
                      id="nationalCode"
                      size="sm"
                      type="number"
                      v-model="form.nationalCode"
                      class="text-center"
                    />
                  </b-col>
                </b-row>
                <b-row class="my-3">
                  <b-col sm="3">
                    <label for="address" class="ps_label">{{label.form.address}} </label>
                  </b-col>
                  <b-col sm="9">
                    <b-form-textarea
                        id="address"
                        rows="1"
                        v-model="form.address"
                    >
                    </b-form-textarea>
                  </b-col>
                </b-row>
              </b-col>
              <b-col cols="6">
                <b-row class="my-4 justify-content-center align-self-center">
                  <b-col cols="12" class="profile-avatar align-self-center">
                    <b-row class="align-self-center">
                      <label for="avatarb" class="ps_label text-center ms-4 mb-3">
                        <b-icon
                            icon="pencil-square"
                            scale="1.2"
                            class="align-middle ms-2"
                        />
                        {{label.pages.editProfile}}
                      </label>
                    </b-row>
                    <img
                        id="avatarb"
                        :src="form.imageAddress"
                        alt="user avatar"
                        @click="clickAvatar"
                    />
                    <input type="file" ref="avatar" id="avatar" class="fs10 mt-1" hidden v-on:change="handleFileUpload()"/>
                  </b-col>
                  <b-col cols="12" class="text-center pt-4">
                    <b-button
                        variant="ps-danger"
                        size="sm"
                        @click="deleteAvatar"
                    >
                      <b-icon icon="trash" scale="0.9" class="ms-1 align-middle"/>
                      {{label.buttons.deleteAvatar}}
                    </b-button>
                  </b-col>
                </b-row>
              </b-col>
            </b-row>
          </b-card-text>
          <template #footer>
            <div class="d-flex justify-content-end">
              <b-button
                  variant="ps-success"
                  size="sm"
                  class="mx-2"
                  @click="editProfile"
              >
                <b-icon icon="check2-circle" class="ms-1 align-middle"/>
                {{label.buttons.recordInfo}}
              </b-button>
            </div>
          </template>
        </b-card>
      </b-col>
      <b-col lg="4" md="12" sm="12">
        <b-card class="ps-card">
          <template #header>
            <b-row class="pt-1">
              <b-col cols="10" class="d-flex">
                <h4 class="me-2">
                  {{label.pages.editPassword}}
                </h4>
              </b-col>
              <b-col cols="2" class="dir-text-start">
                <a
                    @click="$router.go(-1)"
                    v-b-tooltip.hover.right
                    :title="label.pages.previousPage"
                    class="mouse-change pe-3"
                >
                  <b-icon
                      icon="arrow-left-square-fill"
                      variant="ps-base"
                      scale="1.2"
                      class="align-middle ms-1"
                  />
                </a>
              </b-col>
            </b-row>
          </template>
          <b-card-text>
            <b-row>
              <b-col cols="12">
                <b-row class="my-4">
                  <b-col cols="4">
                    <label for="oldPass" class="ps_label">
                      <b-icon icon="lock-fill" class="ms-1"/>
                      {{label.form.currentPassword}}
                    </label>
                  </b-col>
                  <b-col cols="8">
                    <b-form-input id="oldPass" size="sm" v-model="oldPass" type="password"/>
                  </b-col>
                </b-row>
                <b-row class="my-4">
                  <b-col cols="4">
                    <label for="newPass" class="ps_label">
                      <b-icon icon="unlock-fill" class="ms-1"/>
                      {{label.form.newPassword}}
                    </label>
                  </b-col>
                  <b-col cols="8">
                    <b-form-input id="newPass" size="sm" v-model="newPass" type="password"/>
                  </b-col>
                </b-row>
                <b-row class="my-4">
                  <b-col cols="4">
                    <label for="confirmPass" class="ps_label">
                      <b-icon icon="unlock-fill" class="ms-1"/>
                      {{label.form.repeatPassword}}
                    </label>
                  </b-col>
                  <b-col cols="8">
                    <b-form-input id="confirmPass" size="sm" v-model="confirmPass" type="password"/>
                  </b-col>
                </b-row>
              </b-col>
            </b-row>
          </b-card-text>
          <template #footer>
            <div class="d-flex justify-content-end">
              <b-button
                  variant="ps-success"
                  size="sm"
                  class="mx-1"
                  @click="editPassword"
              >
                <b-icon icon="check2-circle" class="ms-1 align-middle"/>
                {{ label.buttons.savePassword }}
              </b-button>
            </div>
          </template>
        </b-card>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import {mapGetters} from 'vuex'
import label from "@/plugins/StaticLabels.js";

export default {
  name: 'AdminProfile',
  data() {
    return {
      label,
      avatar: null,
      oldPass: null,
      newPass: null,
      confirmPass: null,
    }
  },
  computed: {
    ...mapGetters({
      postCheck: 'postCheck',
      form: 'baseX/profile'
    }),
  },
  watch: {
    postCheck() {
      if (this.postCheck === true) {
        this.reloadData();
      }
    },
  },
  methods: {
    clickAvatar() {
      this.$refs.avatar.click();
    },
    handleFileUpload() {
      let formData = new FormData();
      this.avatar = this.$refs.avatar.files[0];
      if (this.avatar != null) {
        formData.append('Image', this.avatar);
      }
      this.$store.dispatch('baseX/editAvatar', formData);
    },
    deleteAvatar(){
      this.$store.dispatch('baseX/deleteAvatar');
    },
    editProfile() {
      this.$store.dispatch('baseX/editProfile', this.form);
    },
    editPassword() {
      if (this.oldPass != null || this.newPass != null || this.confirmPass != null) {
        const values = {
          oldPassword: this.oldPass,
          newPassword: this.newPass,
        };
        this.$store.dispatch('baseX/editPassword', values);
      } else {
        const msg = 'لطفا تمامی فیلدهای مورد نیاز را وارد کنید';
        this.$store.commit('setInfo', msg);
      }
    },
    reloadData() {
      this.$store.dispatch('baseX/getProfile');
    },
  },
  beforeCreate() {
    this.$store.dispatch('baseX/getProfile');
  },
}
</script>
